module.exports = "magnifier-bigger"